<div class="card growth-wrap">
   <div class="card-header card-no-border pb-0">
     <div class="header-top">
       <h5>{{ 'Recruitments Delay' | translate }}</h5>
       <div class="dropdown icon-dropdown">
         <button class="btn dropdown-toggle" id="growthdropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="icon-more-alt"></i></button>
         <div class="dropdown-menu dropdown-menu-end" aria-labelledby="growthdropdown"><a class="dropdown-item" href="#">{{ 'Weekly' | translate }}</a><a class="dropdown-item" href="#">{{ 'Monthly' | translate }}</a><a class="dropdown-item" href="#">{{ 'Yearly' | translate }}</a></div>
       </div>
     </div>
   </div>
   <div class="card-body">
     <div class="growth-wrapper">
       <div id="growthchart">
         <apx-chart [series]="followersGrowth.series" [chart]="followersGrowth.chart" [grid]="followersGrowth.grid" [colors]="followersGrowth.colors" [stroke]="followersGrowth.stroke" [xaxis]="followersGrowth.xaxis" [fill]="followersGrowth.fill" [yaxis]="followersGrowth.yaxis" [responsive]="followersGrowth.responsive"></apx-chart>
       </div>
     </div>
   </div>
 </div>